import React from "react";

type SidebarItemProps = {
  active?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
};

export function SidebarItem({ active = false, icon, children }: SidebarItemProps) {
  const containerClass = `mb-[4px] rounded-[6px] py-[12px] pr-[12px] pl-[24px] ${
    active ? "bg-primary-100" : "hover:bg-neutral-100"
  }`;
  const textClass = active
    ? "text-primary-600"
    : "text-neutral-700 hover:text-primary-600 hover:color-primary-600";

  return (
    <div className={containerClass}>
      <div className={`flex items-center ${textClass}`}>
        {icon && <div className="mr-[12px]">{icon}</div>}
        <span className="text-[14px] font-medium">{children}</span>
      </div>
    </div>
  );
}
